/**
 * Auflösung von Asset-/Download-URLs relativ zur API-Basis.
 *
 * Kursbilder/PDFs werden vom Backend unter /assets bzw. /downloads ausgeliefert
 * (gleiche Origin wie die API). Bloße Dateinamen (z. B. "bg14.png") werden hier
 * zur vollen URL ergänzt; absolute URLs bleiben unverändert.
 */
import { config } from "../config";
import { OPTIMIZED_ASSETS } from "./optimized-assets";

function isAbsolute(url: string): boolean {
  return /^(https?:)?\/\//i.test(url) || url.startsWith("data:");
}

/**
 * Bild-/Asset-URL. Für bekannte Bilder liefert die App ihre EIGENE, optimierte
 * WebP-Variante aus dem App-Webroot (klein, schnell, offline-cachebar) — sonst
 * fällt sie auf den API-Host zurück (z. B. neue Kursbilder ohne lokale Variante).
 */
export function assetUrl(file: string | null | undefined): string | null {
  if (!file) return null;
  if (isAbsolute(file)) return file;
  const clean = file.replace(/^\/+/, "");
  const name = clean.split("/").pop() || clean;
  const base = name.replace(/\.[^.]+$/, "");
  if (OPTIMIZED_ASSETS.has(base)) return `/assets/${base}.webp`;
  // Bereits mit Pfad (assets/…, downloads/…) → nur an Basis hängen.
  if (clean.includes("/")) return `${config.apiBaseUrl}/${clean}`;
  return `${config.apiBaseUrl}/assets/${clean}`;
}

export function downloadUrl(file: string): string {
  if (isAbsolute(file)) return file;
  return `${config.apiBaseUrl}/downloads/${file.replace(/^\/+/, "")}`;
}
